import { render } from "./IndustriesView.vue?vue&type=template&id=44abfe2b&scoped=true"
import script from "./IndustriesView.vue?vue&type=script&lang=js"
export * from "./IndustriesView.vue?vue&type=script&lang=js"

import "./IndustriesView.vue?vue&type=style&index=0&id=44abfe2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44abfe2b"]])

export default __exports__